import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Lazy, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/lazy/lazy.min.css';
import { LazyOptions } from 'swiper/types';
import { ComponentJSSClasses } from './styles';
import { Room } from '../../../../../models/hotel-room-types';
import { IconSliderNavigation } from '../../../Icons/IconSliderNavigation';
import { SliderItem } from '../../SliderItem';
import { checkIsRandomRoom } from '../../../../../../utils/room';
import { Photo } from '../../../../../models/hotel-room-types';

SwiperCore.use([Pagination, Navigation, Lazy]);

export interface RoomGalleryProps {
  photos: Photo[];
  room: Room;
}
interface StyledRoomGalleryProps
    extends RoomGalleryProps,
        JSSClassesProps<ComponentJSSClasses> {}

export const RoomGallery = ({
    room,
    classes,
}: StyledRoomGalleryProps) => {
    const isRandomRoom = React.useMemo(() => room.facilities?.find(f => checkIsRandomRoom(f.id)) , [room]);
    const navigationPrevRef = React.useRef<HTMLButtonElement>(null);
    const navigationNextRef = React.useRef<HTMLButtonElement>(null);
    let photos = room.photos ?? [];

    function renderBullet(_index: any, className: any) {
        return photos.length > 1
            ? `<button class='${className} ${classes.sliderBullets}' type="button"/>`
            : ``;
    }

    function swiperInit(swiper: SwiperCore) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        swiper.params.navigation.nextEl = navigationNextRef.current;
        swiper.navigation.init();
        swiper.navigation.update();
    }


    if (!photos.length) {
      return (
        <div className={classes.roomPlaceholderImage} />
      );
    }

    return (
      <section className={classes.sliderWrapper}>
        {isRandomRoom && <div className={classes.randomTag}>
          Случайный
        </div>}
          <Swiper
              slidesPerView={1}
              spaceBetween={20}
              draggable={true}
              lazy={
                  {
                      enabled: true,
                      checkInView: true,
                      loadPrevNext: true,
                  } as LazyOptions
              }
              preloadImages={true}
              loop={true}
              pagination={{
                  clickable: true,
                  clickableClass: classes.swiperPagination,
                  bulletActiveClass: classes.activeSliderBullets,
                  renderBullet,
              }}
              navigation={{
                  prevEl: navigationPrevRef.current,
                  nextEl: navigationNextRef.current,
              }}
              onInit={swiperInit}
              className={`${classes.swiper}`}
          >
              {photos.map((photo, idx) => (
                  <SwiperSlide key={`${idx}_tourSlide`}>
                      <SliderItem
                          url={photo.url}
                          title={photo.name}
                      />
                  </SwiperSlide>
              ))}

              {photos.length > 1 && (
                  <>
                      <button
                          className={
                              classes.sliderNavButtonPrev
                          }
                          ref={navigationPrevRef}
                          type="button"
                      >
                          <IconSliderNavigation />
                      </button>
                      <button
                          className={
                              classes.sliderNavButtonNext
                          }
                          ref={navigationNextRef}
                          type="button"
                      >
                          <IconSliderNavigation />
                      </button>
                  </>
              )}
          </Swiper>
      </section>
    );
};
